import { useEffect, useState } from 'react'
import useIsBrowser from './useIsBrowser'

export const useActiveTabKey = (tabSetName: string, defaultTabKey: string): [string, (activeTab: string) => void] => {
  // biome-ignore lint/suspicious/noImplicitAnyLet: ignore existing biome errors
  let storedTabsSetValue
  const isBrowser = useIsBrowser()

  if (isBrowser) storedTabsSetValue = window.localStorage.getItem(tabSetName)

  const [tabKey, setTabKey] = useState<string>(storedTabsSetValue || defaultTabKey)

  useEffect(() => {
    if (isBrowser) window.localStorage.setItem(tabSetName.toString(), tabKey)
  }, [tabKey])

  // Quickfix, avoid permanent redirect to rolling-credit
  if (tabSetName === 'CUSTOMER' && tabKey === '6') {
    setTabKey('0')
    return ['0', setTabKey]
  }

  return [tabKey, setTabKey]
}

export default useActiveTabKey
